var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        id: "Ebene_3",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M101.936,74.979c-4.091-6.556-10.205-11.719-17.468-14.622c5.606-4.448,9.206-11.315,9.206-19.027\n\tc0-13.41-10.871-24.281-24.281-24.281S45.113,27.921,45.113,41.331c0,7.978,3.849,15.057,9.79,19.484\n\tC48.06,63.799,42.3,68.801,38.375,75.069",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "70.45", cy: "50.85", r: "46.989" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }